import React from 'react';

export const informationSteps = [
    {
        title: 'Descarga y pago PILA',
        number: [1, 2],
        description: [
            <>
                Has finalizado la liquidación de nómina. Ahora puedes descargar tu planilla PILA. El cálculo se realiza
                directamente con Aportes en Línea bajo la regulación vigente.
            </>,
            <>
                Antes de realizar el pago, valida que la información sea correcta. Una vez pagada la planilla, podrás consultar el
                histórico y certificados en la sección de Reportes.
            </>,
        ],
    },
    {
        title: 'Modificaciones',
        number: [3, 4],
        description: [
            <>
                Si necesitas <strong>modificar información antes del pago</strong>, regresa al módulo de{' '}
                <strong>Liquidación de Nómina</strong>, realiza los ajustes y vuelve al <strong>módulo PILA</strong>.
            </>,
            <>
                Las modificaciones realizadas en Pymes o aportesenlinea.com no se actualizan automáticamente en este portal, por
                lo que deberán sincronizarse nuevamente.
            </>,
        ],
    },
];

export const MESSAGE_ERROR = 'Queue not found';

export enum InformationSteps {
    FIRST_SECTION,
    SECOND_SECTION,
}
